import { Theme } from './theme'

const breakpoints: Theme['breakpoints'] = ['30em', '48em', '62em', '80em']

export default breakpoints
